import {
  DESTINATIONS,
  PROGRESS_STATUSES,
  type Destination,
  type Item,
  type ProgressStatus,
} from '@easymoving/types';

export type DestinationCounts = Record<Destination, number>;
export type ProgressCounts = Record<ProgressStatus, number>;

export interface ItemStats {
  total: number;
  byDestination: DestinationCounts;
  byProgress: ProgressCounts;
  packed: number;
  unpacked: number;
  undecided: number;
  withoutBox: number;
}

export function computeItemStats(items: Item[]): ItemStats {
  const byDestination = Object.fromEntries(DESTINATIONS.map((d) => [d, 0])) as DestinationCounts;
  const byProgress = Object.fromEntries(PROGRESS_STATUSES.map((s) => [s, 0])) as ProgressCounts;

  let withoutBox = 0;
  for (const it of items) {
    byDestination[it.destination] += 1;
    byProgress[it.progressStatus] += 1;
    if (!it.boxId) withoutBox += 1;
  }

  return {
    total: items.length,
    byDestination,
    byProgress,
    packed: byProgress.packed,
    unpacked: items.length - byProgress.packed,
    undecided: byDestination.undecided,
    withoutBox,
  };
}
